import { Notification } from "@app/shared/atoms/notifications-atom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@design-system/ui/dialog";
import { trans } from "@mongez/localization";

type ContactReplyDialogProps = {
  /** The `contactReplied` notification to show, or null when closed. */
  notification: Notification | null;
  onClose: () => void;
};

/**
 * Popup that shows a student their original contact message and the admin's
 * reply. Both come from the notification `metadata` (no extra fetch).
 */
export function ContactReplyDialog({
  notification,
  onClose,
}: ContactReplyDialogProps) {
  const meta = (notification?.metadata || {}) as {
    message?: string;
    reply?: string;
  };

  return (
    <Dialog
      open={Boolean(notification)}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="rtl:text-right">
            {trans("notifications.contactReply.title")}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 rtl:text-right">
          <div>
            <p className="mb-1 text-xs font-semibold text-gray-500 dark:text-gray-400">
              {trans("notifications.contactReply.yourMessage")}
            </p>
            <p className="whitespace-pre-wrap rounded-lg bg-gray-100 p-3 text-sm text-gray-800 dark:bg-gray-800 dark:text-gray-200">
              {meta.message || "-"}
            </p>
          </div>
          <div>
            <p className="mb-1 text-xs font-semibold text-primary">
              {trans("notifications.contactReply.reply")}
            </p>
            <p className="whitespace-pre-wrap rounded-lg bg-primary/5 p-3 text-sm text-gray-800 dark:bg-primary/10 dark:text-gray-200">
              {meta.reply || "-"}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
